import { render } from "./doctors.vue?vue&type=template&id=bc5b7ecc&scoped=true"
import script from "./doctors.vue?vue&type=script&lang=js"
export * from "./doctors.vue?vue&type=script&lang=js"

import "./doctors.vue?vue&type=style&index=0&id=bc5b7ecc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5b7ecc"]])

export default __exports__